export default __webpack_public_path__ + "static/media/whatsapp.4c21844c.svg";